import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import * as effect from '@framework/workbench/ui/transition/transition-effect-option/transition-effect-list';
import * as React from 'react';
import { MenuConfig } from '@tencent/workbench';

export const effectMenuConfig: MenuConfig[] = [
    {
        name: ActionType.TRANSITION_EFFECT_FADE_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_PUSH_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_SWITCH_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_CUT_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_PULL_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_COVER_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_WARP_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_FLIP_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_GALLERY_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_PRISM_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_EMPTY_MENU,
    },
    {
        name: ActionType.TRANSITION_EFFECT_FLASH_MENU,
    },
    ...[
        effect.fadeSmooth,
        effect.fadeBlack,
        effect.pushBottom,
        effect.pushLeft,
        effect.pushRight,
        effect.pushTop,
        effect.switchLeft,
        effect.switchRight,
        effect.cutNone,
        effect.cutBlack,
        effect.pullRight,
        effect.pullTop,
        effect.pullLeft,
        effect.pullBottom,
        effect.pullRightUp,
        effect.pullRightDown,
        effect.pullLeftUp,
        effect.pullLeftDown,
        effect.coverRight,
        effect.coverTop,
        effect.coverLeft,
        effect.coverBottom,
        effect.coverRightUp,
        effect.coverRightDown,
        effect.coverLeftDown,
        effect.coverLeftUp,
        effect.warpEnlarge,
        effect.warpNarrow,
        effect.newsflash,
        effect.flipRight,
        effect.flipLeft,
        effect.galleryRight,
        effect.galleryLeft,
        effect.prismBottom,
        effect.prismTop,
        effect.prismLeft,
        effect.prismRight,
    ].map(effect => ({
        name: effect.id,
        content: effect.title,
        tooltip: effect.title,
        icon: <img src={effect.icon} alt={''}/>,
    })),
];
